import React from "react"
import MuiGrid, { GridProps } from "@material-ui/core/Grid"

const GridItem = (props: GridProps) => <MuiGrid item {...props} />

export default GridItem